import { object, SchemaOf, string } from 'yup';

import { REQUIRED_FIELD } from '@/config/text.const';
import { UpdateDirectDebitVariables } from '@/graphql/contracts/_generated_/updateDirectDebit.mutation';


export type Fields = Omit<UpdateDirectDebitVariables, 'contractId'>;

export const validationSchema: SchemaOf<Fields> = object().shape({
  directDebitType: string()
    .typeError(REQUIRED_FIELD)
    .required(REQUIRED_FIELD)
});
